<div id="forgot-password" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="forgot-password-form-wrapper" fxFlex="30" fusePerfectScrollbar
        [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="forgot-password-form" style="margin-top: 15%;">

            <div class="logo" fxHide.gt-xs>
                <img src="assets/images/logos/logo_ezycharge_main.png">
            </div>

            <div class="title" style="color: #ffffff;">Recover Your Password</div>
            <div *ngIf="mobileScreen">
                <form name="forgoPasswordForm" [formGroup]="forgotPasswordForm" style="padding-top:21.5px !important"
                    novalidate>

                    <mat-form-field appearance="outline">
                        <mat-label>Mobile</mat-label>
                        <input matInput formControlName="mobile" type="tel" maxlength="10">
                        <mat-icon matSuffix class="secondary-text"
                            style="color:#1c5483 !important">smartphone</mat-icon>
                        <!-- <mat-error *ngIf="forgotPasswordForm.get('mobile').hasError('required')">
                            Mobile is required
                        </mat-error> -->
                        <mat-error *ngIf="forgotPasswordForm.get('mobile').hasError('required')">Mobile number is
                            required
                        </mat-error>
                        <mat-error *ngIf="forgotPasswordForm.get('mobile').hasError('pattern')">Please enter valid
                            mobile number
                        </mat-error>

                    </mat-form-field>

                    <button mat-raised-button class="submit-button" color="accent" (click)="mobilePassword()"
                        aria-label="SEND RESET LINK" [disabled]="forgotPasswordForm.invalid">
                        Proceed
                    </button>
                    <div class="remember-forgot-password" *ngIf="isSuccessMessage" fxLayout="row" fxLayout.xs="column"
                        fxLayoutAlign="space-between center">
                        <mat-error style="color:white"> <b> {{successMessage}}</b></mat-error>
                    </div>
                    <div class="remember-forgot-password" *ngIf="isErrorMessage" fxLayout="row" fxLayout.xs="column"
                        fxLayoutAlign="space-between center">
                        <mat-error> <b> {{errorMessage}}</b></mat-error>
                    </div>
                    <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end end">
                        <!-- <mat-checkbox class="remember-me" aria-label="Remember Me">
                       Remember Me
                   </mat-checkbox> -->

                        <a class="forgot-password" [routerLink]="'/login'">
                            Login
                        </a>
                    </div>

                </form>
            </div>
            <div *ngIf="otpScreen">
                <form class="form-field-full" [formGroup]="reactiveFormOTP" style="padding-top:10px !important">

                    <p style="font-size: 14px;color: #ffffff;">Enter OTP which sent your registerd number </p>
                    <div fxLayout="row wrap" fxLayoutGap="8px grid">
                        <div fxFlex="100" fxFlex.lt-sm="100">
                            <mat-form-field appearance="outline">
                                <mat-label>OTP</mat-label>
                                <input matInput placeholder="" formControlName="otp" required>
                                <mat-error *ngIf="reactiveFormOTP.get('otp').invalid">Please enter vaild otp
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="100" fxFlex.lt-sm="100" style="text-align:end;padding-bottom:10px !important">
                            <span><a style="font-size:14px;cursor: pointer;text-decoration: underline;"
                                    (click)="resendOTP()">Resend OTP</a></span>
                        </div>
                    </div>
                    <button class="w-full" class="submit-button" mat-raised-button [disabled]="reactiveFormOTP.invalid"
                        (click)="otpSubmit()">Submit</button>
                    <div class="remember-forgot-password" *ngIf="isSuccessMessage" fxLayout="row" fxLayout.xs="column"
                        fxLayoutAlign="space-between center">
                        <mat-error style="color:white"> <b> {{successMessage}}</b></mat-error>
                    </div>
                    <div class="remember-forgot-password" *ngIf="isErrorMessage" fxLayout="row" fxLayout.xs="column"
                        fxLayoutAlign="space-between center">
                        <mat-error> <b> {{errorMessage}}</b></mat-error>
                    </div>
                    <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end end">
                        <!-- <mat-checkbox class="remember-me" aria-label="Remember Me">
                           Remember Me
                       </mat-checkbox> -->

                        <a class="forgot-password" [routerLink]="'/login'">
                            Login
                        </a>
                    </div>
                </form>
            </div>
            <div *ngIf="newPasswordScreen">
                <form class="form-field-full" [formGroup]="reactiveFormPassword" tyle="padding-top:10px !important">

                    <p style="font-size: 14px;color: #ffffff;">Set New Password</p>

                    <mat-form-field appearance="outline">
                        <mat-label>Password</mat-label>
                        <input matInput placeholder="" [type]="isPasswordFieldType ? 'text' : 'password'"
                            formControlName="password" required style="text-transform: none;">
                        <mat-icon (click)="togglePasswordFieldType()" style="color:#1c5483 !important"
                            matSuffix>{{isPasswordFieldType ? 'visibility_off'
                            : 'visibility'}}</mat-icon>
                        <mat-error *ngIf="reactiveFormPassword.get('password').invalid">Please enter password
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Confirm password</mat-label>
                        <input matInput placeholder="" [type]="isPasswordConfirmFieldType ? 'text' : 'password'"
                            formControlName="c_password" required style="text-transform: none;">
                        <mat-icon (click)="togglePasswordConfirmFieldType()" style="color:#1c5483 !important"
                            matSuffix>{{isPasswordConfirmFieldType ?
                            'visibility_off' : 'visibility'}}</mat-icon>
                        <mat-error *ngIf="reactiveFormPassword.get('c_password').hasError('required')">Please confirm
                            your password!</mat-error>
                        <mat-error *ngIf="reactiveFormPassword.get('c_password').hasError('confirm')">Password is
                            inconsistent! </mat-error>
                    </mat-form-field>
                    <button class="w-full" mat-raised-button class="submit-button"
                        [disabled]="reactiveFormPassword.invalid" (click)="submit()">Submit</button>
                    <div class="remember-forgot-password" *ngIf="isSuccessMessage" fxLayout="row" fxLayout.xs="column"
                        fxLayoutAlign="space-between center">
                        <mat-error style="color:white"> <b> {{successMessage}}</b></mat-error>
                    </div>
                    <div class="remember-forgot-password" *ngIf="isErrorMessage" fxLayout="row" fxLayout.xs="column"
                        fxLayoutAlign="space-between center">
                        <mat-error> <b> {{errorMessage}}</b></mat-error>
                    </div>
                </form>


                <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="end end">
                    <!-- <mat-checkbox class="remember-me" aria-label="Remember Me">
                   Remember Me
               </mat-checkbox> -->

                    <a class="forgot-password" [routerLink]="'/login'">
                        Login
                    </a>
                </div>

            </div>
            <div class="forgot-password" fxLayout="column" style="position:absolute;bottom: 10px;color:#ffffff; ">
                <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto" name="form"
                    style="margin-bottom: 10px;">
                    <div fxFlex="100">
                        <a href="#" style="font-size:  0.8em ;" target="_blank">About Us</a>&nbsp;&nbsp;
                        <a href="#" style="padding-left:5px;font-size:  0.8em;" target="_blank">Contact
                            Us</a>&nbsp;&nbsp;
                        <a href="#" style="padding-left:5px;font-size:  0.8em;" target="_blank">Privacy & Policy</a>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto" name="form"
                    style="margin-bottom: 10px;">
                    <div fxFlex="100">
                        <a href="#" style="padding-bottom:5px;font-size:  0.8em;" target="_blank">Product
                            Services</a>&nbsp;&nbsp;
                        <a href="#" style="padding-left:5px;font-size: 0.8em;" target="_blank">Refund & Cancellation
                            Policy</a>
                    </div>

                </div>

                Powered By Ezy Charge. Version(1.0.1)
            </div>
        </div>
    </div>
    <div id="v-line"></div>
    <div id="forgot-password-intro" fxFlex="70" fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="assets/images/logos/logo_ezycharge_main.png">
        </div>

        <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
            Welcome to the Ezy Charge!
        </div>

        <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
            We are powering next generation mobility by delivering innovative EV charging infrastructure and
            Li-ion batteries for all segments of vehicles.
        </div>

    </div>